import { gql } from '@apollo/client';
import { WorkflowType } from 'modules/workflows/enums';
import { SearchCombo } from 'modules/workflows/types';

export interface YesNoSplitQueryVariables {
  journeyId: number;
  workflowType: WorkflowType;
  tileId: number;
  searchQuery: SearchCombo;
  userKey: string;
  projectId: number;
}

/**
 * Queries which path a yes/no split will take for a given user.
 */
export const YES_NO_SPLIT_TEST_QUERY = gql`
  query yesNoSplitTest(
    $journeyId: Long!
    $workflowType: WorkflowType!
    $tileId: Long
    $searchQuery: Json!
    $userKey: String!
    $projectId: Long!
  ) {
    yesNoSplitTest(
      journeyId: $journeyId
      workflowType: $workflowType
      tileId: $tileId
      searchQuery: $searchQuery
      userKey: $userKey
      projectId: $projectId
    ) {
      workflowProcessResult
    }
  }
`;
